import React, { useEffect, useState } from "react";

const LimparCache: React.FC = () => {
  const [status, setStatus] = useState("Limpando cache...");

  useEffect(() => {
    const limpar = async () => {
      try {
        // 🔹 1. Limpa localStorage e sessionStorage
        localStorage.clear();
        sessionStorage.clear();

        // 🔹 2. Remove todos os caches (Service Workers)
        if ("caches" in window) {
          const keys = await caches.keys();
          await Promise.all(keys.map(key => caches.delete(key)));
        }

        // 🔹 3. Remove todos os bancos IndexedDB
        if (window.indexedDB && indexedDB.databases) {
          const dbs = await indexedDB.databases();
          dbs.forEach(db => {
            if (db.name) indexedDB.deleteDatabase(db.name);
          });
        } else {
          // fallback se o navegador não suportar indexedDB.databases()
          indexedDB.deleteDatabase("localforage");
          indexedDB.deleteDatabase("workbox");
        }

        // 🔹 4. Remove service workers registrados
        if ("serviceWorker" in navigator) {
          const registrations = await navigator.serviceWorker.getRegistrations();
          for (const registration of registrations) {
            await registration.unregister();
          }
        }

        setStatus("✅ Cache completamente limpo! A página será recarregada...");
        setTimeout(() => {
          window.location.href = "/";
        }, 3000);
      } catch (err) {
        console.error("Erro ao limpar cache:", err);
        setStatus("⚠️ Ocorreu um erro ao limpar o cache.");
      }
    };

    limpar();
  }, []);

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#0d1117",
        color: "#fff",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <h2 style={{ marginBottom: "10px" }}>Limpeza de Cache</h2>
      <p>{status}</p>
    </div>
  );
};

export default LimparCache;
